var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', _vm._b({
    attrs: {
      "name": "fade-transition"
    }
  }, 'transition', _vm.$attrs, false), [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };